import React from "react";
import DashboardHeader from "./DashboardHeader";
import DashboardMetrics from "./DashboardMetrics";
import TrendChart from "./TrendChart";
import MarketsOrStoresPanel from "./MarketsOrStoresPanel";
import OperationalHealth from "../OperationalHealth";
import { AccountProvider } from "../account-context";
import { useMarket } from "../contexts/MarketContext";

/**
 * Reusable Dashboard Layout
 * Used by both Global and Market views
 */
const DashboardLayout = ({ 
  mode = 'global', // 'global' | 'market'
  marketCode = null,
  marketName = null,
  accountId = null,
  onBackClick = null,
}) => {
  // Which market view is showing lives in the URL, not in this component, so
  // the drill-down gets its own history entry and Back returns to the market
  // dashboard instead of jumping all the way out to global.
  const { isOperationalView, navigateToOperational, navigateToMarketDashboard } =
    useMarket();
  const showOperationalHealth = mode === 'market' && isOperationalView;

  console.log(`[DashboardLayout] Mode: ${mode}, ShowOpsHealth: ${showOperationalHealth}`);

  const handleMarketDashboardClick = navigateToOperational;
  const handleBackToMarketDashboard = navigateToMarketDashboard;

  // ============================================
  // CONDITIONAL RENDERING - OPERATIONAL HEALTH VIEW
  // ============================================
  if (mode === 'market' && showOperationalHealth) {
    return (
      <div className="dashboard-layout">
        {/* Back to Market Dashboard Header */}
        <div className="dashboard-header-wrapper">
          <div className="dashboard-back-container">
            <button 
              className="dashboard-back-button"
              onClick={handleBackToMarketDashboard}
              aria-label="Back to Market Dashboard"
            >
              <span>←</span> Back to Market Dashboard
            </button>
          </div>

          <div className="dashboard-header">
            <div className="dashboard-header-left">
              <div className="health-section">
                <h3 className="health-title">Operational Health</h3>
              </div>
            </div>

            <div className="vertical-divider"></div>

            <div className="dashboard-header-right">
              <h3 className="health-title">
                {marketName} ({marketCode}) - Detailed View
              </h3>
              <p className="dashboard-overview-subtitle">
                Real-time operational health metrics for {marketName}
              </p>
            </div>
          </div>
        </div>

        {/* Operational Health Component - FULL VIEW */}
        <div className="operational-health-container">
          <AccountProvider 
            accountId={accountId}
            userEmail="" // Pass from parent props if available
            language="en"
            setLanguage={() => {}}
          >
            <OperationalHealth />
          </AccountProvider>
        </div>
      </div>
    );
  }

  // ============================================
  // DEFAULT RENDERING - MARKET/GLOBAL DASHBOARD VIEW
  // ============================================
  return (
    <div className="dashboard-layout">
      {/* Header with Market Dashboard Button (only in market mode) */}
      <DashboardHeader 
        mode={mode}
        marketCode={marketCode}
        marketName={marketName}
        accountId={accountId}
        onBackClick={onBackClick}
        onMarketDashboardClick={handleMarketDashboardClick}
        showOperationalHealth={showOperationalHealth}
      />

      {/* Metrics Cards */}
      <DashboardMetrics 
        mode={mode}
        marketCode={marketCode}
        accountId={accountId}
      />

      {/* Charts and Tables Row */}
      <div className="global-content-row">
        <TrendChart 
          mode={mode}
          marketCode={marketCode}
          accountId={accountId}
        />
        
        <MarketsOrStoresPanel 
          mode={mode}
          marketCode={marketCode}
          accountId={accountId}
        />
      </div>
    </div>
  );
};

export default DashboardLayout;
